export default class Util {

    public static getParamFromUrl(key: string): string | null {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const result = urlParams.get(key);
        return result;
    }

    public static isEmpty(s: string): boolean {
        return !s || s.trim() === '';
    }

    public static isNotEmpty(s: string): boolean {
        return !this.isEmpty(s);
    }

}